import Vue from 'vue';
import Vuex from 'vuex';
import modal from './modules/modal';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        modal,
    },
    state: {
        user: JSON.parse(sessionStorage.getItem('userInfo')) || null, // 用于存储用户信息，初始时为null表示未登录
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user; // 设置用户信息
            sessionStorage.setItem('userInfo', JSON.stringify(user));
        },
        LOGOUT(state) {
            state.user = null; // 登出，清除用户信息
        },
    },
    actions: {
        login({ commit }, user) {
            // 这里可以添加异步操作，例如调用API进行登录验证
            // 假设登录成功，我们通过mutation来更新状态
            commit('SET_USER', user);
        },
        logout({ commit }) {
            commit('LOGOUT'); // 触发登出操作
        },
    }
});